import { Routes } from "@angular/router";
import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { AuthGuard } from "@auth0/auth0-angular";

export const routes: Routes = [
  {
    path: "",
    component: AdminLayoutComponent,
    children: [
      {
        path: "dashboard",
        loadComponent: () =>
          import("./pages/dashboard/dashboard.component").then(
            (m) => m.DashboardComponent
          ),
        canActivate: [AuthGuard],
        data: { preload: true },
      },
      {
        path: "statistics",
        loadComponent: () =>
          import("./pages/statistics/statistics.component").then(
            (m) => m.StatisticsComponent
          ),
        canActivate: [AuthGuard],
        data: { preload: true },
      },
      {
        path: "statistics/:id",
        loadComponent: () =>
          import(
            "./pages/statistics/statistic-detail/statistic-detail.component"
          ).then((m) => m.StatisticDetailComponent),
        canActivate: [AuthGuard],
        data: { preload: true },
      },
      {
        path: "login",
        loadComponent: () =>
          import("./pages/login/login.component").then((m) => m.LoginComponent),
        data: { preload: true },
      },
      {
        path: "logout",
        loadComponent: () =>
          import("./pages/logout/logout.component").then(
            (m) => m.LogoutComponent
          ),
        canActivate: [AuthGuard],
        data: { preload: true },
      },
      {
        path: "",
        redirectTo: "login",
        pathMatch: "full",
      },
      {
        path: "**",
        redirectTo: "login",
      },
    ],
  },
];
